import React, { Component } from 'react';
import lang from './../../../../../../languages/en';
import { alertError, alertSuccess, confirmChangeItem, alertWarning } from './../../../../../../services/dialog';
import hanldeException from './../../../../../../services/handleException';
import { copyData, iconEmpty, setHeight, trimData } from './../../../../../../services/helper';
import { getListItemName } from './../../../../../../utils/getListItemName';
import { update } from './../../../../../../utils/settingMerchant';
import RowProhibitedItems from './../row-prohibited-items';
import { rowItemName, focusTblInputNewFirst } from './../row-prohibited-items/helper';
import { SORT_ITEM_BY } from '../../../../../../constants'

const fieldRequired = ['sku', 'item_code', 'en_title']
const FILTER_VALUES = {
    SKU: 'SKU',
    CreatedDT: 'CreatedDT',
    CreatedDT_DESC: 'CreatedDT'
}

class RowsProhibitedItems extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listItemName: [],
            restoreItemName: [],
            listProhibitedModel: [],
            checkedAll: this.props.checkedAll
        }
        this.newItemName = []
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setHeight()
    }
    static getDerivedStateFromProps(props, state) {
        if (props.checkedAll !== state.checkedAll) {
            let listItemNameNew = [];
            let checked = props.checkedAll;
            for (let key in state.listItemName) {
                let item = state.listItemName[key]
                listItemNameNew.push({
                    ...item,
                    HasApproveKeyWordBL: checked,
                    hasEdit: true
                })
            }
            props.isEditItemFuns('isEdit', true)
            return {
                listItemName: listItemNameNew,
                checkedAll: props.checkedAll
            }
        }
    }

    checkIsAllApprove() {
        let listItemName = this.state.listItemName;
        let isCheckAllApprove = true;
        if (listItemName.length > 0) {
            for (let key in listItemName) {
                if (!listItemName[key].HasApproveKeyWordBL) {
                    isCheckAllApprove = false;
                    break;
                }
            }
        } else {
            isCheckAllApprove = false;
        }

        this.setState({
            checkedAll: isCheckAllApprove
        })
        this.props.onChangeCheckedAll(isCheckAllApprove)

    }

    loadData = (currentPage = 1, pageSize = 10, channel_id = 1, filterValues = {}, sortParams = {}) => {
        let _that = this;
        this.props.handleLoading(true);
        return new Promise((rs, rj) => {
            let data = {
                PageSize: pageSize,
                Page: currentPage,
                ChannelID: channel_id,
                SKU: (filterValues && filterValues.sku) || undefined,
                ItemCode: (filterValues && filterValues.itemCode) || undefined,
                ItemNameEn: (filterValues && filterValues.itemNameEn) || undefined,
                ItemNameJp: (filterValues && filterValues.itemNameJp) || undefined,
                CountryOfOrigin: (filterValues && filterValues.countryOfOrigin) || undefined,
                OrderBy: FILTER_VALUES[(filterValues && filterValues.OrderBy)] || undefined,
                isDesc: (filterValues && filterValues.OrderBy) === SORT_ITEM_BY.CreatedDT_DESC || undefined,
                HasApprove: (filterValues && filterValues.hasApprove),
                IsItemMaster: false,
                KeySearch: (filterValues && filterValues.keywordSearch)
            }


            getListItemName(data).then(res => {
                let listItemName = []
                let restoreItemName = []
                let collectIdItemCurrent = []
                let listItemNameNew = []
                let result = res.data.data.result
                let { pagination } = this.props

                if (res.data.code === 10001) {
                    _that.props.onchangeLineNumberHasProhibited(result.LineNumberHasProhibited);
                    _that.props.onchangeNumberProhibited(result.NumberProhibited);
                    _that.props.onchangeProhibitedModel(result.ProhibitedModel)
                    listItemName = result.AllItemNameResults
                    if (listItemName.length === 0 && !data.keywordSearch) {
                        _that.props.onChangeKeywordSearch('All')
                    }
                    listItemName.map((e, i) => {
                        listItemNameNew.push({
                            checked: false,
                            openRow: false,
                            key: Date.now(),
                            id: e.ID,
                            sku: trimData(e.SKU),
                            item_code: trimData(e.ItemCode),
                            en_title: trimData(e.ItemName_US),
                            jp_title: trimData(e.ItemName_JP),
                            country_of_origin: trimData(e.CountryOfOriginCH),
                            hasEdit: false,
                            HasApproveKeyWordBL: e.HasApproveKeyWordBL,
                            ProhibitedKeyWord: e.ProhibitedKeyWord,
                            classes: {
                                sku: '',
                                item_code: '',
                                en_title: '',
                                jp_title: '',
                                country_of_origin: ''
                            },
                        })
                        collectIdItemCurrent.push(e.ID)
                        return false;
                    })
                    restoreItemName = copyData(listItemNameNew)
                    pagination.countItemName = ((result && result.ItemNameCount) ? result.ItemNameCount : 0)
                    pagination.pageCount = result.PageCount
                    pagination.currentPage = currentPage

                    this.props.inforPagination(pagination)
                    this.props.collectIdItemCurrent(collectIdItemCurrent)
                    this.props.isEditItemFuns('isEdit', false)
                    this.setState({
                        restoreItemName,
                        listItemName: listItemNameNew
                    }, () => {
                        this.checkIsAllApprove()
                        this.checkErrorInput()
                        if (typeof sortParams === 'object' && sortParams.rowAddInit) {
                            for (let i = 0; i < sortParams.rowAddInit; i++) {
                                this.addNewRow();
                            }
                            focusTblInputNewFirst();
                        }
                    });
                } else {
                    hanldeException(res);
                }
                this.props.handleLoading(false)
                rs('done')
            }).catch(err => {
                rj(err)
                hanldeException(err);
            })
        })
    }

    checkErrorInput = () => {
        let error = [],
            hasError = false
        this.state.listItemName.map(e => {
            let classsArray = Object.keys(e.classes)
            for (let i = 0; i < classsArray.length; i++) {
                if (e['classes'][classsArray[i]] === 'error') {
                    error.push('error')
                }
            }
        })
        if (error.length) {
            hasError = true
        }
        this.props.checkErrorInput(hasError)
    }

    restoreItemName = () => {
        this.setState({
            listItemName: copyData(this.state.restoreItemName),
        })
    }

    openRestore = (id) => {
        let restoreItemName = copyData(this.state.restoreItemName)
        restoreItemName.map((e, i) => {
            if (id === e.id) {
                e.openRow = true
            }
            return e;
        })
        this.setState({
            listItemName: restoreItemName,
        })
    }

    changeFieldInput = (value, name, id, typeAction) => {
        let listItemName = this.state.listItemName.map((e, i) => {
            if (name === 'openRow') {
                e['openRow'] = false
            }
            if (e.id === id) {
                e[name] = value
                typeAction === 'onChange' && (e.hasEdit = true)
            }
            return e
        })
        this.setState({
            listItemName
        }, () => {
            this.checkIsAllApprove();
            this.checkErrorInput()
        })
    }

    async asyncAddNewRow() {
        /*if (isSaveRows) { // save when row exists edited
            await this.saveItemName({isNotLoadData: true});
        }*/
        const { pagination, filterValues, channelActive } = this.props
        await this.loadData(pagination.pageCount, pagination.pageSize, channelActive, filterValues)
        await this.addNewRow()
    }

    addNewRow = () => {
        let { listItemName } = this.state
        let { pagination, collectIdItemCurrentValue } = this.props
        this.props.isEditItemFuns('isEdit', false)
        if (listItemName.length >= pagination.pageSize) {
            if (this.isExistsEmptyListItemName(listItemName)) {
                return true;
            }
            collectIdItemCurrentValue = []
            pagination.currentPage++;
            pagination.pageCount++;
            pagination.countItemName++
            if (pagination.currentPage > pagination.pageCount) {
                pagination.currentPage = pagination.pageCount;
            }
            listItemName = []
            listItemName.push(rowItemName())
            collectIdItemCurrentValue.push(rowItemName().id)
            this.props.collectIdItemCurrent(collectIdItemCurrentValue)
            this.setState({
                listItemName
            })
            this.props.inforPagination(pagination)
        } else { // add new row to page has data => old page
            pagination.countItemName++
            listItemName.push(rowItemName())
            collectIdItemCurrentValue.push(rowItemName().id)
            this.props.collectIdItemCurrent(collectIdItemCurrentValue)
            this.setState({
                listItemName
            })
        }

        // scroll bottom when add row
        setTimeout(function () {
            window.scrollTo(0, document.getElementById("setting-merchant").scrollHeight)
            focusTblInputNewFirst();
        }, 50);
    }

    /**
     * check all item is add row
     */
    isExistsEmptyListItemName = (items) => {
        return items.some((item) => {
            return item.addRow;
        });
    }

    /**
     * check item all input empty?
     */
    isEmptyItem = (item) => {
        if (item.country_of_origin ||
            item.en_title ||
            item.item_code ||
            item.jp_title ||
            item.sku ||
            !item.addRow
        ) {
            return false;
        }
        return true;
    }

    saveItemName = (typeSave = null, notReload, callback) => {
        const { listItemName } = this.state
        const { filterValues, channelActive } = this.props
        let checkError = 0
        var that = this;
        let statusHandle = null
        Object.keys(listItemName).forEach(function (key) {
            if (that.isEmptyItem(listItemName[key])) {
                return true;
            }
            Object.keys(listItemName[key]['classes']).forEach(function (keyChild) {
                if (fieldRequired.indexOf(keyChild) !== -1 && !listItemName[key][keyChild]) {
                    listItemName[key]['classes'][keyChild] = 'error'
                }
                if (listItemName[key]['classes'][keyChild] === 'error') {
                    checkError += 1
                }
            })
        })

        this.setState({
            listItemName
        }, () => {
            this.checkErrorInput()
            const { currentPage, pageSize } = this.props.pagination
            let listItemNameNew = listItemName.filter(e => {
                return e.hasEdit === true
            });
            listItemNameNew = listItemNameNew.filter(item => {
                // add row data empty => not push data to server
                if (this.isEmptyItem(item)) {
                    return false;
                }
                return true;
            }).map(item => {
                return {
                    SKU: item.sku,
                    ItemCode: item.item_code,
                    ItemName_US: item.en_title,
                    ItemName_JP: item.jp_title,
                    CountryOfOriginCH: item.country_of_origin,
                    ID: item.id,
                    HasApproveKeyWordBL: item.HasApproveKeyWordBL
                }
            })
            let data = {
                ChannelId: this.props.channelActive,
                ItemNames: listItemNameNew
            }
            if (checkError) {
                alertError(lang.field_some_required);
                return;
            }
            this.props.handleLoading(true)
            update(data).then(res => {
                switch (res.data.code) {
                    case 10001:
                        if (typeSave && typeSave.type === 'applyFilter') {
                            alertSuccess(lang.update_item_name_success, null,
                                () => this.loadData(typeSave.currentPage, typeSave.pageSize, typeSave.channelActive, typeSave.filterValues))
                        } else {
                            let rowAddInit = 0;
                            // add row add new after load ajax list item name
                            if (typeSave && (typeSave.type === 'addNewRow' || typeSave.isAddedLoad)) {
                                rowAddInit = 1;
                            }
                            alertSuccess(lang.update_item_name_success, null, () => {
                                focusTblInputNewFirst();
                                callback && typeof callback === 'function' && callback();
                            });
                            this.props.isEditItemFuns('isEdit', false);

                            if (!notReload || (typeSave && typeSave.isAddedLoad)) {
                                that.loadData(currentPage, pageSize, channelActive, filterValues, { rowAddInit: rowAddInit });
                            }
                        }
                        if (typeSave && typeSave.type === 'saveChangePaginate') {
                            this.props.handlePagination(typeSave.currentPage)
                        }
                        break;
                    case 213304:
                        hanldeException(res)
                        // this.loadData(currentPage, pageSize, this.props.channelActive)
                        break;
                    case 213309:
                        alertError(lang.item_name_not_exist)
                        this.refRows.checkedAll(false)
                        this.loadData(currentPage, pageSize, channelActive, filterValues)
                        break;
                    default:
                        hanldeException(res)
                        this.loadData(currentPage, pageSize, channelActive, filterValues)
                        break;
                }
                this.props.handleLoading(false)
            }).catch(err => {
                hanldeException(err);
                this.props.handleLoading(false)
            })
        })
        return statusHandle
    }

    checkItemCheckedInList = () => {
        let collectIdItem = this.props.idItemName
        let result = false
        let { collectIdItemCurrentValue } = this.props
        const { listItemName } = this.state

        if (!collectIdItem.length || !listItemName.length) return;
        let listItemNameNew = listItemName.filter((e, i) => {
            let index = collectIdItem.indexOf(e.id)
            let indexCurrent = collectIdItemCurrentValue.indexOf(e.id)
            if (index !== -1) {
                if (!e.addRow) {
                    result = true
                } else {
                    collectIdItemCurrentValue.splice(indexCurrent, 1)
                    collectIdItem.splice(index, 1)
                    this.props.collectIdItemCurrent(collectIdItemCurrentValue)
                    this.props.collectIdItem(collectIdItem)
                }
            }
            return index === -1;
        })
        this.setState({
            listItemName: listItemNameNew
        })
        return result
    }

    checkFieldSku = (value, name, rowID) => {
        if (name === 'sku') {
            let skuData = []
            this.state.listItemName.map((e, i) => {
                if (value && e.sku === value) {
                    skuData.push(i)
                }
                return false;
            })
            if (skuData.length > 1) {
                alertWarning(lang.sku_dumplicate)
                let itemNew = this.state.listItemName.map((ej, j) => {
                    if (ej.sku === value && ej.id === rowID) {
                        ej['classes'][name] = 'error'
                        ej[name] = ''
                    }
                    return ej;
                })
                this.setState({
                    listItemName: itemNew
                })
            }
        }
    }

    renderRows = () => {
        const { listItemName } = this.state
        if (!listItemName.length) {
            return (
                <tr>
                    <td colSpan={8}>{iconEmpty()}</td>
                </tr>
            )
        }
        return listItemName.map((e, i) => {
            return (
                <RowProhibitedItems
                    key={i}
                    itemName={e}
                    handleLoading={this.props.handleLoading}
                    restoreItemName={this.restoreItemName}
                    changeFieldInput={this.changeFieldInput}
                    idItemName={this.props.idItemName}
                    openRestore={this.openRestore}
                    isEdit={this.props.isEdit}
                    isEditItemFuns={this.props.isEditItemFuns}
                    checkFieldSku={this.checkFieldSku}
                    currentShortChannel={this.props.currentShortChannel}
                    prohibitedItems={this.props.prohibitedItems}
                />
            )
        })
    }

    render() {
        return (
            <tbody>
                {this.renderRows()}
            </tbody>
        );
    }
}

export default RowsProhibitedItems


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/rows-prohibited-items/index.js